import React, { useMemo } from "react";
import OrdersByMonth from "../maintenance/OrdersByMonth";


function SiteServicesOrders() {
  const dayRange = 180;

  const { fromDate, toDate } = useMemo(() => {
    const start = new Date();
    const end = new Date(start);
    end.setDate(end.getDate() + dayRange);
    return { fromDate: start, toDate: end };
  }, [dayRange]);

  return (
    <OrdersByMonth fromDate={fromDate} toDate={toDate} resource="_REMA:MILJO" />
  );
}

export default SiteServicesOrders;
